
<template>
  <div class="search-container">
    <div class="search-box">
      <input
          v-model="searchText"
          type="text"
          placeholder=""
          @focus="isFocused = true"
          @blur="isFocused = false"
          @keyup.enter="handleSearch"
      />
      <div class="search-icon" @click="handleSearch">
        <svg viewBox="0 0 24 24">
          <path d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 1 0-.7.7l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchText: '',
      isFocused: false
    }
  },
  methods: {
    handleSearch() {
      this.$emit('search', this.searchText)
    },
    clearSearch() {
      this.searchText = ''
      this.$emit('clear')
    }
  }
}
</script>

<style scoped>
.search-container {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}

.search-box {
  position: relative;
  border:1px solid #dedfe0;
  width: 100%;
  max-width: 600px;
  height: 28px;
  display: flex;
  align-items: center;
  border-radius: 30px;
  background: #f5f5f5;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  /*box-shadow: 0 2px 10px rgba(0,0,0,0.05);*/
}

.search-box.focused {
  background: white;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  transform: translateY(-2px);
}

.search-box input {
  flex: 1;
  padding: 0 20px;
  border: none;
  background: transparent;
  font-size: 12px;
  outline: none;
  color: #333;
}

.search-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.search-icon svg {
  width: 20px;
  height: 20px;
  fill: #666;
  transition: all 0.3s;
}

.search-box.focused .search-icon svg {
  fill: #4285f4;
}

.clear-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s;
}

.clear-btn:hover {
  background: rgba(0,0,0,0.05);
}

.clear-btn svg {
  width: 18px;
  height: 18px;
  fill: #999;
}

.scale-enter-active, .scale-leave-active {
  transition: all 0.3s;
}
.scale-enter, .scale-leave-to {
  transform: scale(0.5);
  opacity: 0;
}
</style>
